if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.hideErrors = this.dataset.hideErrors === 'true';


        // If a variant was preserved across a market switch, respect its sold-out state.
        // The global __preservedVariant is set by the inline restoration script in
        // product-variant-picker.liquid. It fires BEFORE this constructor runs because
        // buy-buttons (which contains <product-form>) is rendered AFTER variant_picker.
        if (window.__preservedVariant) {
          var pv = window.__preservedVariant;
          // Set the correct variant ID in the hidden input
          this.variantIdInput.value = pv.id;
          if (pv.isUnavailable) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.classList.add('disabled');
            var soldOutLabel = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
            if (this.submitButtonText) this.submitButtonText.textContent = soldOutLabel;
          }
        } else if (this.submitButton.getAttribute('aria-disabled') === 'true') {
          this.submitButton.setAttribute('disabled', 'disabled');
        }

    }

    async onSubmitHandler(evt) {
        evt.preventDefault();
        if(document.body.classList.contains('body_system') || document.body.classList.contains('body_switch-aero') || document.body.classList.contains('body_stem')){
            return false;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const configBase = fetchConfig('javascript');
        configBase.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete configBase.headers['Content-Type'];
        const mainFormData = new FormData(this.form);
        if (this.cart) {
            mainFormData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
            );
            mainFormData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
        }
        const productFormElement = document.querySelector('#product__info_main product-form form');
        if (productFormElement) {
            const customProductInputs = productFormElement.querySelectorAll('input[name="add_custom_product"]');
            if (customProductInputs.length > 0) {
                for (const productInput of customProductInputs) {
                    const productId = productInput.value;
                    const productFormData = new FormData();
                    productFormData.set('id', productId);
                    productFormData.set('quantity', 1);
                    const fetchConfigOptions = {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        },
                        body: productFormData
                    };
                    try {
                        const response = await fetch(`${routes.cart_add_url}`, fetchConfigOptions);
                        const responseData = await response.json();

                        if (responseData.status) {
                            console.error('Error adding product:', responseData.errors || responseData.description);
                            this.handleErrorMessage(responseData.description);
                            this.error = true;
                            continue;
                        } else if (!this.cart) {
                            window.location = window.routes.cart_url;
                            return;
                        } else if (this.cart) {
                            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                            if (!this.error) {
                                await publish(PUB_SUB_EVENTS.cartUpdate, {
                                    source: 'product-form',
                                    productVariantId: productId,
                                    cartData: responseData,
                                });
                                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                            }

                            CartPerformance.measure("add:paint-updated-sections", () => {
                                this.cart.renderContents(responseData);
                            });
                        }
                    } catch (error) {
                        console.error('Fetch error:', error);
                    }
                }
            }
        }
        try {
            const mainConfig = { ...configBase, body: mainFormData };
            const mainResponse = await fetch(`${routes.cart_add_url}`, mainConfig);
            const mainData = await mainResponse.json();
            if (mainData.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: mainFormData.get('id'),
                    errors: mainData.errors || mainData.description,
                    message: mainData.message,
                });
                this.handleErrorMessage(mainData.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (soldOutMessage) {
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                }
                this.error = true;
            } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
            } else {
                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                if (!this.error) {
                    await publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: mainFormData.get('id'),
                        cartData: mainData,
                    });
                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                }
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                    document.body.addEventListener(
                        'modalClosed',
                        () => {
                            setTimeout(() => {
                                CartPerformance.measure("add:paint-updated-sections", () => {
                                    this.cart.renderContents(mainData);
                                });
                            });
                        },
                        { once: true }
                    );
                    quickAddModal.hide(true);
                } else {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(mainData);
                    });
                }
            }
        } catch (error) {
            console.error('Fetch error:', error);
        } finally {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
        }
    }

    handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
    }

    toggleSubmitButton(disable = true, text) {

                // If a variant was preserved and is unavailable, never re-enable the button
        // until the user manually selects a different variant.
        if (!disable && window.__preservedVariant && window.__preservedVariant.isUnavailable) {
          return;
        }

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
    }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//     constructor() {
//         super();
//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');
//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//         this.hideErrors = this.dataset.hideErrors === 'true';
//     }

//     async onSubmitHandler(evt) {
//         evt.preventDefault();
        
//         // ✅ UPDATED: Specific body classes ke liye bhi cart drawer open karo
//         const isSpecialBody = document.body.classList.contains('body_system') || 
//                              document.body.classList.contains('body_switch-aero') || 
//                              document.body.classList.contains('body_stem');
        
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
//         this.handleErrorMessage();
//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');
        
//         const configBase = fetchConfig('javascript');
//         configBase.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete configBase.headers['Content-Type'];
        
//         const mainFormData = new FormData(this.form);
//         if (this.cart) {
//             mainFormData.append(
//                 'sections',
//                 this.cart.getSectionsToRender().map((section) => section.id)
//             );
//             mainFormData.append('sections_url', window.location.pathname);
//             this.cart.setActiveElement(document.activeElement);
//         }
        
//         const productFormElement = document.querySelector('#product__info_main product-form form');
//         let allProductsAddedSuccessfully = true;
//         const addedProductIds = [];

//         // ✅ ADD-ONS KO PEHLE ADD KARO
//         if (productFormElement) {
//             const customProductInputs = productFormElement.querySelectorAll('input[name="add_custom_product"]');
//             if (customProductInputs.length > 0) {
//                 for (const productInput of customProductInputs) {
//                     const productId = productInput.value;
//                     const productFormData = new FormData();
//                     productFormData.set('id', productId);
//                     productFormData.set('quantity', 1);
//                     const fetchConfigOptions = {
//                         method: 'POST',
//                         headers: {
//                             'X-Requested-With': 'XMLHttpRequest'
//                         },
//                         body: productFormData
//                     };
//                     try {
//                         const response = await fetch(`${routes.cart_add_url}`, fetchConfigOptions);
//                         const responseData = await response.json();

//                         if (responseData.status) {
//                             console.error('Error adding product:', responseData.errors || responseData.description);
//                             this.handleErrorMessage(responseData.description);
//                             this.error = true;
//                             allProductsAddedSuccessfully = false;
//                             continue;
//                         } else {
//                             addedProductIds.push(productId);
//                             console.log('✅ Add-on product added:', productId);
                            
//                             if (this.cart) {
//                                 const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//                                 if (!this.error) {
//                                     await publish(PUB_SUB_EVENTS.cartUpdate, {
//                                         source: 'product-form',
//                                         productVariantId: productId,
//                                         cartData: responseData,
//                                     });
//                                     CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//                                 }

//                                 CartPerformance.measure("add:paint-updated-sections", () => {
//                                     this.cart.renderContents(responseData);
//                                 });
//                             }
//                         }
//                     } catch (error) {
//                         console.error('Fetch error:', error);
//                         allProductsAddedSuccessfully = false;
//                     }
//                 }
//             }
//         }

//         // ✅ MAIN PRODUCT KO ADD KARO
//         try {
//             const mainConfig = { ...configBase, body: mainFormData };
//             const mainResponse = await fetch(`${routes.cart_add_url}`, mainConfig);
//             const mainData = await mainResponse.json();
            
//             if (mainData.status) {
//                 publish(PUB_SUB_EVENTS.cartError, {
//                     source: 'product-form',
//                     productVariantId: mainFormData.get('id'),
//                     errors: mainData.errors || mainData.description,
//                     message: mainData.message,
//                 });
//                 this.handleErrorMessage(mainData.description);

//                 const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//                 if (soldOutMessage) {
//                     this.submitButton.setAttribute('aria-disabled', true);
//                     this.submitButtonText.classList.add('hidden');
//                     soldOutMessage.classList.remove('hidden');
//                 }
//                 this.error = true;
//                 allProductsAddedSuccessfully = false;
//             } else if (!this.cart) {
//                 window.location = window.routes.cart_url;
//                 return;
//             } else {
//                 addedProductIds.push(mainFormData.get('id'));
//                 console.log('✅ Main product added:', mainFormData.get('id'));
                
//                 const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//                 if (!this.error) {
//                     await publish(PUB_SUB_EVENTS.cartUpdate, {
//                         source: 'product-form',
//                         productVariantId: mainFormData.get('id'),
//                         cartData: mainData,
//                     });
//                     CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//                 }
//                 this.error = false;
                
//                 const quickAddModal = this.closest('quick-add-modal');
//                 if (quickAddModal) {
//                     document.body.addEventListener(
//                         'modalClosed',
//                         () => {
//                             setTimeout(() => {
//                                 CartPerformance.measure("add:paint-updated-sections", () => {
//                                     this.cart.renderContents(mainData);
//                                 });
                                
//                                 // ✅ SPECIAL BODY CLASSES KE LIYE CART DRAWER OPEN
//                                 if (isSpecialBody && allProductsAddedSuccessfully) {
//                                     setTimeout(() => {
//                                         this.openCartDrawer();
//                                     }, 1000);
//                                 }
//                             });
//                         },
//                         { once: true }
//                     );
//                     quickAddModal.hide(true);
//                 } else {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                         this.cart.renderContents(mainData);
//                     });
                    
//                     // ✅ CART DRAWER OPEN KARO - ALL CASES INCLUDING SPECIAL BODY CLASSES
//                     if (allProductsAddedSuccessfully && addedProductIds.length > 0) {
//                         setTimeout(() => {
//                             this.openCartDrawer();
//                         }, 800);
//                     }
//                 }
//             }
//         } catch (error) {
//             console.error('Fetch error:', error);
//             allProductsAddedSuccessfully = false;
//         } finally {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent("add:user-action", evt);
            
//             // ✅ FALLBACK: Agar upar wala cart drawer open nahi hua toh
//             if (isSpecialBody && allProductsAddedSuccessfully) {
//                 setTimeout(() => {
//                     this.forceOpenCartDrawer();
//                 }, 1500);
//             }
//         }
//     }

//     // ✅ NEW FUNCTION: CART DRAWER OPEN
//     openCartDrawer() {
//         try {
//             console.log('🛒 Attempting to open cart drawer...');
            
//             // Cart drawer element find karo
//             const cartDrawer = document.querySelector('cart-drawer');
            
//             if (cartDrawer) {
//                 console.log('✅ Cart drawer found, opening...');
                
//                 // Method 1: open() function call karo
//                 if (typeof cartDrawer.open === 'function') {
//                     cartDrawer.open();
//                     console.log('✅ Cart drawer opened using open() method');
//                 } 
//                 // Method 2: show() function call karo
//                 else if (typeof cartDrawer.show === 'function') {
//                     cartDrawer.show();
//                     console.log('✅ Cart drawer opened using show() method');
//                 }
//                 // Method 3: Attributes set karo
//                 else {
//                     cartDrawer.setAttribute('open', '');
//                     cartDrawer.classList.add('active', 'animate', 'is-visible');
//                     document.body.classList.add('overflow-hidden');
//                     console.log('✅ Cart drawer opened using attributes');
//                 }
                
//                 // Cart contents refresh karo
//                 this.refreshCartContents();
                
//             } else {
//                 console.warn('⚠️ Cart drawer element not found');
//                 // Fallback: Cart notification show karo
//                 this.openCartNotification();
//             }
//         } catch (error) {
//             console.error('❌ Error opening cart drawer:', error);
//             this.fallbackOpenCart();
//         }
//     }

//     // ✅ NEW FUNCTION: FORCE CART DRAWER OPEN (SPECIAL BODY CLASSES KE LIYE)
//     forceOpenCartDrawer() {
//         try {
//             console.log('💪 Force opening cart drawer for special body classes...');
            
//             const cartDrawer = document.querySelector('cart-drawer');
            
//             if (cartDrawer) {
//                 // Multiple methods try karo
//                 const methods = [
//                     () => { if (typeof cartDrawer.open === 'function') cartDrawer.open(); },
//                     () => { if (typeof cartDrawer.show === 'function') cartDrawer.show(); },
//                     () => { 
//                         cartDrawer.setAttribute('open', ''); 
//                         cartDrawer.classList.add('active', 'animate', 'is-visible');
//                         document.body.classList.add('overflow-hidden');
//                     },
//                     () => { cartDrawer.dispatchEvent(new Event('open')); },
//                     () => { 
//                         const event = new CustomEvent('cart:toggle', { bubbles: true });
//                         document.dispatchEvent(event);
//                     }
//                 ];
                
//                 for (let method of methods) {
//                     try {
//                         method();
//                         console.log('✅ Force method executed');
//                         break;
//                     } catch (e) {
//                         console.log('⚠️ Force method failed, trying next...');
//                     }
//                 }
                
//                 // Extra refresh for special body classes
//                 setTimeout(() => {
//                     this.refreshCartContents();
//                 }, 500);
                
//             } else {
//                 console.log('🔄 No cart drawer found, using alternative methods...');
//                 this.fallbackOpenCart();
//             }
//         } catch (error) {
//             console.error('❌ Force open failed:', error);
//         }
//     }

//     // ✅ NEW FUNCTION: CART CONTENTS REFRESH
//     refreshCartContents() {
//         fetch(`${routes.cart_url}.js`)
//             .then(response => response.json())
//             .then(cartData => {
//                 console.log('🔄 Refreshing cart contents...');
                
//                 // Cart drawer refresh karo
//                 const cartDrawer = document.querySelector('cart-drawer');
//                 if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//                     cartDrawer.renderContents(cartData);
//                 }
                
//                 // Cart notification refresh karo
//                 const cartNotification = document.querySelector('cart-notification');
//                 if (cartNotification && typeof cartNotification.renderContents === 'function') {
//                     cartNotification.renderContents(cartData);
//                 }
                
//                 // Header cart count update karo
//                 this.updateCartCount(cartData.item_count);
                
//                 console.log('✅ Cart contents refreshed successfully');
//             })
//             .catch(error => {
//                 console.error('❌ Error refreshing cart contents:', error);
//             });
//     }

//     // ✅ NEW FUNCTION: CART NOTIFICATION OPEN (FALLBACK)
//     openCartNotification() {
//         const cartNotification = document.querySelector('cart-notification');
//         if (cartNotification) {
//             if (typeof cartNotification.show === 'function') {
//                 cartNotification.show();
//                 console.log('✅ Cart notification shown');
//             } else if (typeof cartNotification.open === 'function') {
//                 cartNotification.open();
//                 console.log('✅ Cart notification opened');
//             }
//         } else {
//             console.warn('⚠️ Cart notification not found');
//         }
//     }

//     // ✅ NEW FUNCTION: CART COUNT UPDATE
//     updateCartCount(itemCount) {
//         // Cart count bubbles update karo
//         const cartCountElements = document.querySelectorAll('.cart-count-bubble span, .cart-count span, [data-cart-count]');
//         cartCountElements.forEach(element => {
//             element.textContent = itemCount;
//         });
        
//         // Events publish karo for other components
//         if (typeof publish === 'function') {
//             publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 cartData: { item_count: itemCount }
//             });
//         }
        
//         console.log('🔢 Cart count updated to:', itemCount);
//     }

//     // ✅ NEW FUNCTION: FALLBACK CART OPEN
//     fallbackOpenCart() {
//         try {
//             console.log('🔄 Using fallback cart opening methods...');
            
//             // Method 1: Cart icon click karo
//             const cartIcons = document.querySelectorAll('a[href="/cart"], [data-drawer-toggle="cart"], .cart-icon, [aria-controls="cart-drawer"]');
//             if (cartIcons.length > 0) {
//                 cartIcons[0].click();
//                 console.log('✅ Cart opened via icon click');
//                 return;
//             }
            
//             // Method 2: Custom event trigger karo
//             const cartEvent = new CustomEvent('cart:toggle', { bubbles: true });
//             document.dispatchEvent(cartEvent);
//             console.log('✅ Cart toggle event dispatched');
            
//             // Method 3: Shopify event trigger karo
//             if (window.Shopify && window.Shopify.cartToggle) {
//                 window.Shopify.cartToggle();
//                 console.log('✅ Shopify cart toggle called');
//             }
            
//             // Method 4: Direct URL (last resort)
//             setTimeout(() => {
//                 console.log('📍 Redirecting to cart page...');
//                 window.location.href = '/cart';
//             }, 2000);
            
//         } catch (error) {
//             console.error('❌ All fallback methods failed:', error);
//         }
//     }

//     handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//     }

//     toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//     }

//     get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }